<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Socso
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="success"
      title="Socso"
      text="Create Socso"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="wages_from"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('from')"
                data-vv-name="from"                
                data-vv-as="From"      
                prefix="RM"          
                label="From"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="wages_to"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('to')"
                data-vv-name="to"                
                data-vv-as="To"  
                prefix="RM"          
                label="To"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="first_category_employer_contribution"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('first_category_employer_contribution')"
                data-vv-name="first_category_employer_contribution"                
                data-vv-as="First Category Employer Contribution"                
                label="First Category Employer's Contribution"
                prefix="RM"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="first_category_employee_contribution"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('first_category_employee_contribution')"
                data-vv-name="first_category_employee_contribution"                
                data-vv-as="First Category Employee Contribution"                
                label="First Category Employee's Contribution"
                prefix="RM"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="first_category_total_contribution"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('first_category_total_contribution')"
                data-vv-name="first_category_total_contribution"                
                data-vv-as="First Category Total Contribution"                
                label="First Category Total Contribution"
                prefix="RM"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="second_category_employer_contribution"
                v-validate="'required|twoDecimalValue'" 
                type="number"
                :error-messages="errors.collect('second_category_employer_contribution')"
                data-vv-name="second_category_employer_contribution"                
                data-vv-as="Second Category Employer Contribution"                
                label="Second Category Employer's Contribution"
                prefix="RM"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    inject: ['$validator'],
    data () {
      return {
        progressing: false,
        dialog: null,
        wages_from: null,
        wages_to: null,
        first_category_employer_contribution: null,
        first_category_employee_contribution: null,
        first_category_total_contribution: null,
        second_category_employer_contribution: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
      },
    },

    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },

    methods: { 
      prepareFormData () {
        return {
          wages_from: this.wages_from * 100,
          wages_to: this.wages_to * 100,
          first_category_employer_contribution: this.first_category_employer_contribution * 100,
          first_category_employee_contribution: this.first_category_employee_contribution * 100,
          first_category_total_contribution: this.first_category_total_contribution * 100,
          second_category_employer_contribution: this.second_category_employer_contribution * 100,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.socso().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new Socso' })

                  this.setDialog(false)                
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      resetForm () {
        this.$validator.reset()
        this.wages_from = null
        this.wages_to = null
        this.first_category_employer_contribution = null
        this.first_category_employee_contribution = null
        this.first_category_total_contribution = null
        this.second_category_employer_contribution = null
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>
